'use strict';

angular.module('imagetrend.components')
    .controller('PageSettingsModalController', ['$scope', '$uibModalInstance', 'continue_button_label', 'show_save_button', 'save_button_label', 'page_name', function ($scope, $uibModalInstance, continue_button_label, show_save_button, save_button_label, page_name) {
        $scope.settings = {};
        $scope.settings.continue_button_label = continue_button_label;
        $scope.settings.show_save_button = show_save_button;
        $scope.settings.save_button_label = save_button_label;
        $scope.settings.changed = false;
        $scope.settings.page_name = page_name;

        $scope.$watch('settings.page_name', function(oldValue, newValue) {
            if (oldValue != newValue) {
                $scope.settings.changed = true;
            }
        });
        $scope.$watch('settings.continue_button_label', function(oldValue, newValue) {
            if (oldValue != newValue) {
                $scope.settings.changed = true;
            }
        });
        $scope.$watch('settings.show_save_button', function (oldValue, newValue) {
            if (oldValue != newValue) {
                $scope.settings.changed = true;
            }
        });
        $scope.$watch('settings.save_button_label', function (oldValue, newValue) {
            if (oldValue != newValue) {
                $scope.settings.changed = true;
            }
        });

        $scope.save = function () {
            $uibModalInstance.close($scope.settings);
        }
        $scope.cancel = function () {
            $uibModalInstance.close(null);
        }

    }])
;